<template>
    <highcharts :options="chartOptions"></highcharts>
</template>

<script>
  export default {
    name: 'PlayerPointsChart',
    props: ['weeks', 'weeklyStats'],
    data() {
      return {
        chartOptions: {
          chart: {
            type: 'area'
          },
          title: '',
          credits: {
            enable: false
          },
          xAxis : {
            categories: []
          },
          plotOptions: {
            area: {
              fillOpacity: .2
            }
          },
          tooltip: {
            shared: true
          },
          yAxis: [{
            height:125,
            max: 0,
            top: 176,
            offset: 0,
            title: {
              text: ''
            },
            labels: {
              formatter: function () {
                var r = this.value < 0 ? this.value : null;

                return r;
              },
              reserveSpace: false
            }
          },{
            min: 0,
            top: 50,
            height: 125,
            title: {
              text: ''
            },
            labels: {
              formatter: function () {
                var r = this.value >= 0 ? this.value : null;

                return r;
              }

            }
          }],
          series: []
        }
      }
    },
    methods: {
      updateChartData() {
        let chartData = {
          categories: [],
          series: [
            {
              name: 'Par',
              yAxis: 0,
              data: [],
              color: '#777'
            }, {
              name: 'Points',
              yAxis: 1,
              data: []
            }
          ]
        };

        const allWeeks = this.weeks.sort((l,r) => {
          if (l.week_date === r.week_date) return 0;
          return l.week_date > r.week_date ? 1 : -1;
        }).map(w => w.week);

        while (allWeeks.length !== 19) {

          let previousWeek = allWeeks[allWeeks.length - 1];
          // correct for bye week
          previousWeek = previousWeek !== 0 ? previousWeek : allWeeks[allWeeks.length - 2];

          allWeeks.push(previousWeek + 1);
        }

        chartData = allWeeks.reduce((result, week) => {
          let item = this.weeklyStats.find(card => card.week === week);

          // fill in missing weeks
          item = item || {
            week,
            points: 0,
            from_par: 0
          };

          // Add to chart
          result.categories.push((item.week === 0 ? 'Bye Week' : 'Week ' + item.week));
          result.series[1].data.push(parseFloat(item.points));
          result.series[0].data.push(parseInt(item.from_par));
          return result;
        }, chartData);

        this.chartOptions.series =  chartData.series;
        this.chartOptions.xAxis.categories = chartData.categories;
      }
    },
    watch: {
      'weeklyStats': 'updateChartData'
    },
    created () {
      this.updateChartData()
    }
  }
</script>

<style>

</style>
